import styled from 'styled-components'

export const SkeletonGrid = styled.div`
  display: grid;
  width: 100%;
  max-width: 1520px;
  grid-template-columns: minmax(0, 1.68fr) minmax(320px, 0.82fr);
  gap: 32px;
  align-items: start;

  @media (max-width: 1180px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const SkeletonLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const SkeletonRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const SkeletonMediaCard = styled.div`
  padding: 0;
`

export const SkeletonSectionCard = styled.div`
  overflow: hidden;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 16px;
  background: ${p => p.theme.palette.colors.backgroundStrong};
  box-shadow: 0 18px 34px ${p => p.theme.palette.colors.shadowStrong};
`

export const SkeletonSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
`

export const SkeletonCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`

export const SkeletonStatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const SkeletonStatCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 96px;
  padding: 16px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 16px;
  background: ${p => p.theme.palette.colors.surfaceSoft};
  box-shadow: 0 14px 30px ${p => p.theme.palette.colors.shadowStrong};
`

export const SkeletonLessonRows = styled.div`
  display: flex;
  flex-direction: column;
`

export const SkeletonLessonRow = styled.div`
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 20px;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};

  > div {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }
`
